import { Module } from "vuex";
import { RootState } from "../RootState";
import { AutonomousFormCheckboxFormTypeService } from "../../services/AutonomousFormCheckboxFormTypeService";
import { CheckboxFormType } from "../../models/CheckboxFormType";
import { CheckboxFormTypeUpdate } from "../../models/requests/CheckboxFormTypeUpdate";

export interface AutonomousFormCheckboxFormTypeState {
  checkboxFormType: CheckboxFormType[];
}

// Magasin VueX qui coordonne l'échange d'infos entre les différentes vues.
export const autonomousFormCheckboxFormTypeModule: Module<
  AutonomousFormCheckboxFormTypeState,
  RootState
> = {
  namespaced: true,
  // Données partagées du magasin (ne peuvent pas être modifiées directement)
  state: {
    checkboxFormType: []
  },

  // Accesseurs pour propriétés calculées
  getters: {},

  // Opérations de modification des données
  mutations: {
    /**
     * Updates autonomousFormBaseCheckboxes
     */
    setCheckboxFormType(state, value: CheckboxFormType[]) {
      state.checkboxFormType = value;
    },

    /**
     * Adds or update an additional Checkbox
     * @param state
     * @param value
     */
    addOrUpdateCheckboxFormType(state, value: CheckboxFormType) {
      const index = state.checkboxFormType.findIndex(
        val => val.idCheckbox === value.idCheckbox
      );
      if (index > -1) {
        state.checkboxFormType.splice(index, 1, value);
      } else {
        state.checkboxFormType.push(value);
      }
    }
  },

  // Actions pouvant être appelées par les vues pour agir sur le magasin
  actions: {
    async getFormType(
      { commit },
      value: { checkboxId: number; flowId: number }
    ) {
      const response = await AutonomousFormCheckboxFormTypeService.getFormType(
        value.checkboxId,
        value.flowId
      );
      commit("getCheckboxFormType", response.data);
      return response.data;
    },

    async setFormType(
      context,
      value: {
        checkboxId: number;
        formTypeId: number;
        checkboxFormType: CheckboxFormTypeUpdate;
      }
    ) {
      const response = await AutonomousFormCheckboxFormTypeService.setFormType(
        value.checkboxId,
        value.formTypeId,
        value.checkboxFormType
      );
      context.commit("addOrUpdateCheckboxFormType", response.data);
      return response.data;
    }
  }
};
